import { RichText } from 'prismic-reactjs';
import CustomPrismicHeading from '@components/CustomPrismicHeading';
import {
  IPrismicCollection,
  IPrismicImage,
  IPrismicRichText,
} from '@monofront/types';
import LogoCard from '@monofront/design-system/components/LogoCard';
import withSlice from '@screens/SlicesContainer/withSlice';
import { mapBrandslogoList } from './mapBrandsLogoList';

export interface IBrandsLogoList {
  primary?: {
    title?: IPrismicRichText | null;
  };
  items?: [
    {
      logo?: IPrismicImage | null;
      collection?: IPrismicCollection | null;
      trackingId?: string | null;
    },
  ];
}

const BrandsLogoList: React.FC<IBrandsLogoList> = ({ items, primary }) => {
  if (!primary || !items || !items.length) return null;

  return (
    <>
      <section className="brands-logo-list">
        {primary.title && (
          <RichText
            render={primary.title}
            htmlSerializer={CustomPrismicHeading({
              className: 'catchy-title-s',
            })}
          />
        )}

        <ul>
          {items.slice(0, 6).map(({ collection, logo, trackingId }, i) => {
            if (!collection || !logo) return null;

            return (
              <li key={i}>
                <LogoCard
                  visual={logo}
                  label={collection.title}
                  link={`/collections/${collection.handle}${
                    trackingId ? `?trackingId=${trackingId}` : ''
                  }`}
                />
              </li>
            );
          })}
        </ul>
      </section>
      <style jsx>{`
        .brands-logo-list :global(.catchy-title-s) {
          margin-bottom: var(--space-5);
        }

        ul {
          display: flex;
          list-style: none;
          justify-content: space-between;
        }

        @media (max-width: 1200px) {
          ul::-webkit-scrollbar {
            display: none;
          }
          ul {
            margin: 0 var(--negative-layout-margin);
            padding: 0 var(--layout-margin);
            overflow: auto;
            gap: 24px;
          }
          ul::-webkit-scrollbar {
            display: none;
          }
        }

        @media (max-width: 800px) {
          ul {
            margin: var(--negative-padding-layout-base);
            padding: var(--padding-layout-base);
          }
        }
      `}</style>
    </>
  );
};

export default withSlice(BrandsLogoList, mapBrandslogoList);
